import React from 'react';
import { Mail, Phone, MapPin, CheckCircle2 } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 py-12 mt-20">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-white font-bold text-lg mb-4">One Clean Garage</h3>
            <p className="text-sm text-slate-400 mb-3">
              Professional garage cleaning services. Fast quotes, quality work, guaranteed satisfaction.
            </p>
            <div className="inline-flex items-center gap-2 bg-emerald-900/50 text-emerald-300 px-3 py-1.5 rounded-full text-xs font-semibold border border-emerald-700">
              <CheckCircle2 className="h-3 w-3" />
              <span>Licensed & Insured</span>
            </div>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-2 text-sm">
                <Phone className="h-4 w-4 text-emerald-500" />
                <span>386-283-0286</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <Mail className="h-4 w-4 text-emerald-500" />
                <span>lexi@onecleangarage.com</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <MapPin className="h-4 w-4 text-emerald-500" />
                <span>Serving the Greater Orlando Area</span>
              </div>
            </div>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Hours</h4>
            <div className="space-y-2 text-sm">
              <p>Monday - Friday: 7am - 5pm</p>
              <p>Saturday: 8am - 5pm</p>
              <p>Sunday: 8am - 5pm</p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-slate-800 mt-8 pt-8 text-center text-sm text-slate-500">
          <p>&copy; {new Date().getFullYear()} One Clean Garage. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;